/**  页头固定方式 */
export default (props: any, el: Ref<HTMLElement | null>) => {
  const route = useRoute()
  const { height } = useElementBounding(el)

  // 当前的滚动位置
  const currentYPosition = ref(0)

  // 上一次滚动的位置
  const lastYPosition = ref(0)

  // 是否显示页头
  const shouldShowSticky = ref(false)

  // 是否是透明页头
  const isTransparent = computed(() => props.datas?.settings?.header?.settings?.transparent_header)

  // 页头固定方式
  const headerType = computed(() => props.datas?.settings?.header?.settings?.sticky_header_type)

  // 页头固定方式
  const sticky_header_type = computed(() => {
    let type = ''
    // 不固定页头
    if (headerType.value === 'none') {
      type += ' not-sticky'
    }

    // 始终固定页头
    if (headerType.value === 'always') {
      type += ' is-sticky'
    }

    // 向上滚动时固定显示页头
    if (headerType.value === 'on-scroll-up') {
      type += ' on-scroll-up'
    }

    // 是否固定页头
    if (shouldShowSticky.value) {
      type += ' is-sticky-active'
    }

    // 透明页头
    if (isTransparent.value && route.path === '/') {
      if (currentYPosition.value > 0) {
        type += ' is-transparent-active'
      }
      type += ' is-transparent'
    }
    return type
  })

  // 是否显示隐藏页头
  const stickyAlways = computed(() => {
    if (headerType.value === 'always') {
      if (isTransparent.value && route.path === '/')
        return 'is-sticky is-transparent-active'
      return 'is-sticky'
    }

    if (headerType.value === 'on-scroll-up') {
      if (shouldShowSticky.value) {
        return 'is-sticky'
      }
      return 'header-hidden'
    }
    return ''
  })

  function handleScroll() {
    currentYPosition.value = window.pageYOffset || document.documentElement.scrollTop

    if (headerType.value === 'on-scroll-up') {
      // 检查滚动方向
      if (currentYPosition.value < lastYPosition.value && currentYPosition.value > height.value) {
        shouldShowSticky.value = true
      }
      else {
        shouldShowSticky.value = false
      }

      lastYPosition.value = currentYPosition.value
    }
    if (headerType.value === 'always' && isTransparent.value && route.path === '/') {
      // 检查滚动方向
      if (currentYPosition.value > 0 && currentYPosition.value > height.value) {
        shouldShowSticky.value = true
      }
      else {
        shouldShowSticky.value = false
      }
    }
  }

  if (headerType.value === 'on-scroll-up' || headerType.value === 'always' && isTransparent.value && route.path === '/') {
    useEventListener(window, 'scroll', handleScroll)
  }

  return { sticky_header_type, isTransparent, stickyAlways, currentYPosition, lastYPosition }
}
